import httpClient from 'shared/lib/httpClient';

export const updateRole = async (id, payload) => {
  const response = await httpClient.put(`/company-roles/${id}`, payload);
  return response?.data;
};
